/* eslint-disable @next/next/no-html-link-for-pages */
import { useTranslations } from "next-intl";
import classNames from "classnames";
import { defaultLocale } from "@lib/i18n/config";
import { useLocale } from "@lib/i18n/navigation-pages-router";
import Image from "@components/core/Image";
import Link from "@components/core/LinkApp";

const LeClosetLinks = () => {
  const t = useTranslations("common");

  const locale = useLocale();

  return (
    <div className="d-flex flex-column flex-sm-row mb-4 mb-sm-0 footer justify-content-between">
      <section className="d-flex flex-column w-50 mt-4">
        <h5 className="mb-4 w-50 d-none d-sm-block d-md-none-sm-none">
          <Image
            src="logo"
            alt="logo"
          />
        </h5>
      </section>
      <div className="footer-section-container mb-md-0 mt-4">
        <section className="footer-section">
          <h6 className="mb-4">{t("footer.help")}</h6>
          <Link
            href={t("footer.links.help_center.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("footer.links.help_center.text")}
          </Link>
          <Link
            href={t("footer.links.contact_us.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("footer.links.contact_us.text")}
          </Link>
          <a
            href="javascript:openAxeptioCookies()"
            className="link-dark footer-link no-underline"
          >
            {t("footer.links.cookie_preferences.text")}
          </a>

          <h6 className="my-4">{t("footer.services")}</h6>
          <Link
            href={t("footer.links.catalog.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("footer.links.catalog.text")}
          </Link>

          <Link
            href={t("footer.links.gift_cards.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("footer.links.gift_cards.text")}
          </Link>

          <a
            href={t("footer.links.how_it_works.link")}
            className="link-dark footer-link no-underline"
          >
            {t("footer.links.how_it_works.text")}
          </a>
        </section>

        <section className="footer-section">
          <h6 className="mb-4">{t("footer.about")}</h6>
          <Link
            href="/marques"
            className="link-dark footer-link no-underline"
            noUnderline
          >
            {t("footer.links.our_brands.text")}
          </Link>
          <a
            href={t("footer.links.reviews.link")}
            className="link-dark footer-link no-underline"
          >
            {t("footer.links.reviews.text")}
          </a>
          <a
            href={t("footer.links.our_vision.link")}
            className="link-dark footer-link no-underline"
          >
            {t("footer.links.our_vision.text")}
          </a>
          <a
            href={t("footer.links.sustainable_fashion.link")}
            className="link-dark footer-link no-underline"
          >
            {t("footer.links.sustainable_fashion.text")}
          </a>
          <a
            href={t("footer.links.press.link")}
            className="link-dark footer-link no-underline"
          >
            {t("footer.links.press.text")}
          </a>
          <a
            href={t("footer.links.morphology.link")}
            className="link-dark footer-link no-underline"
          >
            {t("footer.links.morphology.text")}
          </a>
          <a
            href={t("footer.links.maternity_clothes_rental.link")}
            className="link-dark footer-link no-underline"
          >
            {t("footer.links.maternity_clothes_rental.text")}
          </a>
          <a
            href={t("footer.links.ambassador.link")}
            className="link-dark footer-link no-underline"
          >
            {t("footer.links.ambassador.text")}
          </a>
        </section>
      </div>
      <section className="d-flex flex-sm-column footer-social-section mt-4 w-50">
        <div className="mb-sm-4 footer-social-section-block">
          <h6 className="mb-4">{t("footer.network")}</h6>
          <div className="d-flex">
            <a
              href="https://www.facebook.com/lecloset.fr?fref=ts"
              className="link-dark no-underline me-4"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                src="facebookFooter"
                alt="logo facebook"
                className="footer-social-section-logo"
              />
            </a>

            <a
              href="https://www.pinterest.fr/Le_Closet"
              className="link-dark no-underline me-4"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                src="pinterest"
                alt="logo pinterest"
                className="footer-social-section-logo"
              />
            </a>

            <a
              href="https://www.instagram.com/leclosetfr"
              className="link-dark no-underline me-4"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                src="instagram"
                alt="logo instagram"
                className="footer-social-section-logo"
              />
            </a>
          </div>
        </div>
        <div
          className={classNames(
            "footer-social-section-block",
            locale === defaultLocale ? "d-flex" : "d-none",
          )}
        >
          <div className="footer-social-section-smartphone-logo me-2">
            <Image
              src="smartphone"
              alt="smartphone"
            />
          </div>
          <div className="footer-social-section-smartphone-links">
            <h6 className="mb-0">{t("footer.app_available")}</h6>
            <h6 className="mb-0">
              <a
                href="https://apps.apple.com/fr/app/le-closet/id1442294906"
                className="link-dark no-underline"
                target="_blank"
                rel="noreferrer"
              >
                {t("footer.ios")}
              </a>
              /
              <a
                href="https://play.google.com/store/apps/details?id=com.lecloset"
                className="link-dark no-underline"
                target="_blank"
                rel="noreferrer"
              >
                {t("footer.android")}
              </a>
            </h6>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LeClosetLinks;
